import { useState } from "react";
import { Input, Progress } from "@chakra-ui/react";
import {
  MotionBox as Box,
  MotionFlex as Flex,
  viewAppearDefault,
} from "utils/motion";
import { useFormatMessage } from "components/base/Trans";

const quickFade = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { type: "tween", duration: 0.1 } },
};

export default function SearchField({ onChange, loading }) {
  const formatMessage = useFormatMessage();
  const [value, setValue] = useState("");
  const handleChange = (event) => {
    setValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <Flex
      position="relative"
      align="center"
      pt={["md", null, "xl"]}
      px={["md", null, "xl"]}
      direction="column"
      bg="black.700"
    >
      <Flex
        w="100%"
        justify="center"
        variants={viewAppearDefault}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.05 }}
      >
        <Input
          maxW="800px"
          value={value}
          onChange={handleChange}
          color="white"
          bg="gray.900"
          borderRadius={4}
          placeholder={formatMessage({ id: "LBL_FAQ_SEARCH" })}
          borderColor="gray.800"
          _active={{
            bgColor: "rgba(216, 216, 216, 0.2)",
            borderColor: "rgba(216, 216, 216, 0.2)",
          }}
          _focus={{
            bgColor: "rgba(216, 216, 216, 0.2)",
            borderColor: "rgba(216, 216, 216, 0.2)",
            boxShadow: "0 0 0px 0px #0fb96099",
          }}
        />
      </Flex>
      <Box
        bottom="5px"
        w="100%"
        maxW="800px"
        px={["lg", null, "sm"]}
        position="absolute"
        variants={quickFade}
        initial="hidden"
        animate={loading ? "visible" : "hidden"}
      >
        <Progress h="2px" isIndeterminate colorScheme="green" />
      </Box>
    </Flex>
  );
}
